export default __webpack_public_path__ + "static/media/Group 27105.5690e50f.svg";